import { useAtomValue, useSetAtom } from 'jotai';
import { setUserSessionAtom, userSessionAtom } from './atoms';

export const useUserSession = () => {
  const data = useAtomValue(userSessionAtom);
  const set = useSetAtom(setUserSessionAtom);

  return { data, set };
};
